import React from "react";
import FormFillContent from "./FormFillContent";
import "./RoleFormFillPage.css";

// Technician/Manager/Developer/Staff/other dynamic role entry point for
// Form Fill — mounted ONLY by routes/DynamicRoutes.jsx. Renders the SAME
// shared FormFillContent component AdminFormFillPage renders.
export default function RoleFormFillPage() {
  return (
    <div className="role-form-page">
      <FormFillContent />
    </div>
  );
}
